import {getNumberFromInput} from '../../../record-editing';
import {
    LabelContainer,
    Label,
    NumberControlShowingEdits,
    ValidationsList,
    RequiredSignifier
} from '../../../components/Form/FormStyles';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {EditedProject} from '../EditedProject';
import {NumericFormFieldContainer} from '../MultipleProjectTypes/NumericFormFieldContainer';

export function TTFDBHControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <NumericFormFieldContainer>
            <LabelContainer>
                {!project.ControlledByAutomation && (
                    <ValidateControl
                        validated={project.TTFDBHValidated.current}
                        disabled={project.TTFDBH.notValidToShowPartner}
                        onChange={(e) =>
                            setProjectAndValidate({
                                ...project,
                                TTFDBHValidated: project.TTFDBHValidated.update(e.validated)
                            })
                        }
                    />
                )}
                <Label htmlFor="dbh">Tree diameter (DBH)</Label>
                <RequiredSignifier />
            </LabelContainer>
            <NumberControlShowingEdits
                id="dbh"
                disabled={project.ControlledByAutomation}
                value={project.TTFDBH}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        TTFDBH: project.TTFDBH.update(getNumberFromInput(e))
                    })
                }></NumberControlShowingEdits>
            <ValidationsList validations={project.TTFDBH.validations} />
        </NumericFormFieldContainer>
    );
}
